import { render, staticRenderFns } from "./old_School_score.vue?vue&type=template&id=1ffd5342&scoped=true&"
import script from "./old_School_score.vue?vue&type=script&lang=js&"
export * from "./old_School_score.vue?vue&type=script&lang=js&"
import style0 from "./old_School_score.vue?vue&type=style&index=0&id=1ffd5342&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd5342",
  null
  
)

export default component.exports